export default {
    root: {
        '& .MuiOutlinedInput-multiline': {
            padding: '0px !important'
        },
    }
};